import React from 'react';
import { Column, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { AutoInvoicingControl } from 'src/components/enterprise/features/Corporate/components/Form/AutoInvoicingWrapper/AutoInvoicingControl/AutoInvoicingControl';

export function AutoInvoicingWrapper(): JSX.Element {
  return (
    <Column phone={6} gutter={12}>
      <Stack y="sm">
        <AutoInvoicingControl
          id="auto-invoicing-enabled"
          name="autoInvoicingEnabled"
        />
      </Stack>
    </Column>
  );
}
